import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import type { Observable } from 'rxjs';
import { Subject, filter, map } from 'rxjs';
import type { ListInterface } from '../models/list-interface';
import type { NotificationInterface } from '../models/notification.interface';
import { TokenStorageService } from './token-storage.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  GetNotificationsQuery = gql`query notifications($take: Int!, $skip: Int!) {
    notifications(order: { createdAt: DESC }, skip: $skip, take: $take) {
      items {
        id
        code
        param
        url
        level
        userId
        clinicId
        createdAt
      }
      totalCount
      pageInfo {
        hasPreviousPage
        hasNextPage
      }
    }
  }`;

  GetNotificationsQueryVariables: { take?: number; skip?: number } = {};

  private readonly _notificationAdded: Subject<NotificationInterface> = new Subject<NotificationInterface>();
  public get notificationAdded(): Subject<NotificationInterface> {
    return this._notificationAdded;
  }

  constructor(private readonly apollo: Apollo, tokenStorageService: TokenStorageService) {
    tokenStorageService.token.pipe(filter(t => !!t)).subscribe(_ => {
      this.listenNotificationAdded();
    });
  }

  getNotifications(skip: number, take: number): Observable<ListInterface<NotificationInterface>> {
    this.GetNotificationsQueryVariables = {
      take,
      skip
    };

    return this.apollo.query<{ notifications: ListInterface<NotificationInterface> }>({
      query: this.GetNotificationsQuery,
      variables : this.GetNotificationsQueryVariables,
      fetchPolicy: 'network-only'
    }).pipe(map(res => res.data.notifications));
  }

  closeNotification(notificationId: number, offset: number): Observable<NotificationInterface | undefined> {
    return this.apollo.mutate<{ closeNotification: NotificationInterface }>({
      mutation : gql`mutation closeNotification($notificationId: Long!, $offset: Long!) {
        closeNotification(notificationId: $notificationId, offset: $offset) {
          id
          code
          param
          url
          level
          userId
          clinicId
          createdAt
        }
      }`,
      variables: {
        notificationId,
        offset
      }
    }).pipe(map(res => res.data ? res.data?.closeNotification : undefined));
  }

  closeAllNotifications(): Observable<NotificationInterface[] | undefined> {
    return this.apollo.mutate<{ closeAllNotifications: NotificationInterface[] }>({
      mutation : gql`mutation closeAllNotifications {
        closeAllNotifications {
          id
          code
          param
          url
          level
          userId
          clinicId
          createdAt
        }
      }`
      // ,
      // update: (store, { data }) => {
      //   if (data?.closeAllNotifications) {
      //     const getNotificationsQuery = store.readQuery<GetNotificationsResponse>({
      //       query: this.GetNotificationsQuery,
      //       variables: this.GetNotificationsQueryVariables
      //     });
      //     if (getNotificationsQuery) {
      //       const listNotifications = getNotificationsQuery.notifications;

      //       const newNotifications = {
      //         notifications: {
      //           items: data.closeAllNotifications.slice(0, this.GetNotificationsQueryVariables.take),
      //           pageInfo: Object.assign({}, listNotifications.pageInfo),
      //           totalCount : data.closeAllNotifications.length
      //         }
      //       };
      //       if ( this.GetNotificationsQueryVariables.take ) {
      //         newNotifications.notifications.pageInfo.hasNextPage = data.closeAllNotifications.length > this.GetNotificationsQueryVariables.take;
      //       }

      //       store.writeQuery<GetNotificationsResponse>({
      //         query: this.GetNotificationsQuery,
      //         variables : this.GetNotificationsQueryVariables,
      //         data : newNotifications
      //       });
      //     }
      //   }
      // },
    }).pipe(map(res => res.data ? res.data?.closeAllNotifications : undefined));
  }

  listenNotificationAdded() {
    this.apollo.subscribe<{ onNotificationAdded: NotificationInterface }>({
      query: gql`subscription onNotificationAdded {
        onNotificationAdded {
          id
          code
          param
          url
          level
          userId
          clinicId
          createdAt
        }
      }`,
    }).subscribe((result) => {
      if (result.data?.onNotificationAdded) {
        const newNotification = result.data.onNotificationAdded;
        console.log(`notification added :${newNotification.id}`);

        // const getNotificationsQuery = this.apollo.client.readQuery<GetNotificationsResponse>({
        //   query: this.GetNotificationsQuery,
        //   variables: this.GetNotificationsQueryVariables
        // });

        // if (getNotificationsQuery) {
        //   const listNotifications = getNotificationsQuery.notifications;
        //   let listNotificationItems = listNotifications.items.map(s=> Object.assign({}, s));
        //   const notificationFound = listNotificationItems.find(s=>s.id === newNotification.id);
        //   let totalCount = listNotifications.totalCount;
        //   if (notificationFound) {
        //     listNotificationItems = listNotificationItems.filter(s=> s.id !== newNotification.id);
        //   } else {
        //     totalCount++;
        //   }

        //   listNotificationItems = [newNotification, ...listNotificationItems];
        //   const newNotifications = {
        //     notifications: {
        //       items: listNotificationItems,
        //       pageInfo: listNotifications.pageInfo,
        //       totalCount
        //     }
        //   };
        //   this.apollo.client.writeQuery<GetNotificationsResponse>({
        //     query: this.GetNotificationsQuery,
        //     variables : this.GetNotificationsQueryVariables,
        //     data : newNotifications
        //   });
        // }

        this.notificationAdded.next(newNotification);
      }
    });
  }
}

export interface GetNotificationsResponse {
  notifications: ListInterface<NotificationInterface>;
}
